import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Logo from "../../assets/images/logo.svg";
import styles from "./Navbar.module.css";
import { NavList } from "../../utils/constants";
import { useGetTopMenusQuery } from "../../api/apiSlice";
import Loader from "../../components/Loader/Loader";
import ErrorMsg from "../../components/ErrorMsg/ErrorMsg";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { logout as logoutApi } from "../../api/auth";
import SidebarContent from "../SideBar/SideBarContent";

export default function Navbar() {
  const navigate = useNavigate();
  const {
    data: response,
    isLoading: loading,
    isError: error,
  } = useGetTopMenusQuery();
  const { userdata, logout } = useAuth();
  const [isSticky, setIsSticky] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { setAuthModal } = useAuth();
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleCloseMenu = () => setIsOpen(false);
  const logoutHandler = async (e) => {
    logout();
    handleCloseMenu();
    try {
      const response = await logoutApi({});
      if (response?.status === 200) {
        localStorage.clear();
        navigate("/");
        setAuthModal({ open: true, tab: "login" });
        toast.success("Logout Successfully", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        logout();
        handleCloseMenu();
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      const message = error.response?.data?.message || "Server error.";
      toast.error(message);
    }
  };
  const menusList = response?.topMenus ?? NavList;
  const isInnerPage =
    location.pathname.startsWith("/mentors") ||
    location.pathname.startsWith("/authors") ||
    /^\/institutions\/\d+/.test(location.pathname) ||
    location.pathname.startsWith("/dashboard");
  const handleRedirection = () => {
    const role = userdata?.role;
    navigate(`/dashboard/${role || "institution"}`);
    handleCloseMenu();
  };

  return (
    <>
      {isOpen && (
        <div className={styles.overlay} onClick={handleCloseMenu}></div>
      )}
      <header
        className={`${styles.nav} ${isSticky ? styles.sticky : ""} ${isInnerPage ? styles.innerPage : ""
          } `}
      >
        <div className={styles.container}>
          <Link to="/" className={styles.logo}>
            <img src={Logo} alt="Imparc" title="Imparc" />
          </Link>
          <nav className={styles.topMenus}>
            {loading ? (
              <Loader />
            ) : error ? (
              <ErrorMsg />
            ) : (
              menusList
                ?.filter((item) => item.status === 1)
                .sort((a, b) => a.id - b.id)
                .map((i) => {
                  return (
                    <NavLink
                      key={i.id}
                      to={i.link}
                      onClick={handleCloseMenu}
                      className={({ isActive }) =>
                        isActive ? styles.activeLink : styles.navItem
                      }
                    >
                      {i.label}
                    </NavLink>
                  );
                })
            )}
            {userdata ? (
              <button className={styles.profileBtn} onClick={handleRedirection}>
                Dashboard
              </button>
            ) : (
              <button
                className={styles.loginBtn}
                onClick={() => setAuthModal({ open: true, tab: "login" })}
              >
                Login
              </button>
            )}
            {userdata ? (
              <button className={styles.logoutBtn} onClick={logoutHandler}>
                Logout
              </button>
            ) : (
              <button
                className={styles.signupBtn}
                onClick={() => setAuthModal({ open: true, tab: "signup" })}
              >
                Signup
              </button>
            )}
          </nav>
          {/* Hamburger */}
          <div
            className={`${styles.hamburger}`}
            onClick={() => setIsOpen(true)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </header>
      {/* Mobile Side Drawer */}
      <aside className={`${styles.sideDrawer} ${isOpen ? styles.show : ""}`}>
        <div className={styles.drawerHeader}>
          <img src={Logo} alt="Imparc" />
          <button className={styles.closeBtn} onClick={handleCloseMenu}>
            ✕
          </button>
        </div>

        <div className={styles.drawerContent}>
          {menusList
            ?.filter((item) => item.status === 1)
            .sort((a, b) => a.id - b.id)
            .map((i) => (
              <NavLink
                key={i.id}
                to={i.link}
                onClick={handleCloseMenu}
                className={styles.drawerItem}
              >
                {i.label}
              </NavLink>
            ))}
          {userdata ? null : (
            <button
              className={styles.loginBtn}
              onClick={() => setAuthModal({ open: true, tab: "login" })}
            >
              Login
            </button>
          )}
          {userdata ? null : (
            <button
              className={styles.signupBtn}
              onClick={() => setAuthModal({ open: true, tab: "signup" })}
            >
              Signup
            </button>
          )}
          {userdata && (
            <SidebarContent handleCloseMenu={handleCloseMenu} fromNav={true} />
          )}
        </div>
      </aside>
    </>
  );
}
